module.exports = __webpack_public_path__ + "img/pressure.d3aeab3f.gif";